export interface PivotReasonOption {
    text: string;
    requiresExplanation: boolean;
}

export const PIVOT_REASONS: {[key: string]: PivotReasonOption[]} = {
    PROSPERIUL: [
        {text: 'Pivot away from Prosper: Eligibility: State Availability', requiresExplanation: false},
        {text: 'Pivot away from Prosper: Eligibility: Over/Underage Limits', requiresExplanation: false},
        {text: 'Pivot away from Prosper: Eligibility: Below Minimum Premium', requiresExplanation: false},
        {text: 'Pivot away from Prosper: Eligibility: Below Minimum Face Amount', requiresExplanation: false},
        {text: 'Pivot away from Prosper: Eligibility: Underwriting Reason (Build, etc.)', requiresExplanation: false},
        {text: 'Pivot away from Prosper: Eligibility: Other Reason', requiresExplanation: true},
        {
            text: 'Pivot away from Prosper: Client Requested: Client Wants Multiple Policies with same Carrier',
            requiresExplanation: false,
        },
        {text: 'Pivot away from Prosper: Client Requested: Higher Cap', requiresExplanation: false},
        {text: 'Pivot away from Prosper: Client Requested: Higher Cash Value', requiresExplanation: false},
        {text: 'Pivot away from Prosper: Client Requested: More Index Options', requiresExplanation: false},
        {text: 'Pivot away from Prosper: Client Requested: Other Reason', requiresExplanation: true},
        {text: 'Pivot away from Prosper: Capability: Owner/Payor Different', requiresExplanation: false},
        {text: 'Pivot away from Prosper: Capability: Replacement Issue', requiresExplanation: false},
        {text: 'Pivot away from Prosper: Capability: Quoting Tech Issue', requiresExplanation: false},
        {text: 'Pivot away from Prosper: Capability: eApp Tech Issue', requiresExplanation: false},
        {text: 'Pivot away from Prosper: Capability: Other Reason', requiresExplanation: true},
        {text: 'Pivot away from Prosper: Other: Resubmit After Prosper Decline', requiresExplanation: false},
        {text: 'Pivot away from Prosper: Other: Other Reason', requiresExplanation: true},
    ],
    FGEVL: [
        {text: "Pivot away from Everlast: Didn't meet minimum face amount", requiresExplanation: false},
        {text: "Pivot away from Everlast: Didn't meet age requirement", requiresExplanation: false},
        {text: 'Pivot away from Everlast: Customer wanted higher CV', requiresExplanation: false},
        {
            text: 'Pivot away from Everlast: Wanted to stay with same product as other family members',
            requiresExplanation: false,
        },
        {text: 'Pivot away from Everlast: Client has 2 or more reported conditions', requiresExplanation: false},
    ],
    BANOPTERM: [
        {text: 'Pivot away from Banner OpTerm: Client Requested: Cost issue', requiresExplanation: false},
        {text: 'Pivot away from Banner OpTerm: Eligibility: Underwriting reason', requiresExplanation: false},
        {text: 'Pivot away from Banner OpTerm: Other: Other reason', requiresExplanation: true},
    ],
    // LSW Flex Life Secure maps to LSWIUL and LSWIULPRF
    LSWIUL: [
        {text: 'Pivot away from LSW Flex Life Secure: Client requested: Wants protection', requiresExplanation: false},
        {text: 'Pivot away from LSW Flex Life Secure: Client requested: Unable to fund', requiresExplanation: false},
        {text: 'Pivot away from LSW Flex Life Secure: Other: Other reason', requiresExplanation: true},
    ],
    LSWANNFSG: [
        {text: 'Pivot away from LSW Flex Life Secure: Client requested: Wants protection', requiresExplanation: false},
        {text: 'Pivot away from LSW Flex Life Secure: Client requested: Unable to fund', requiresExplanation: false},
        {text: 'Pivot away from LSW Flex Life Secure: Other: Other reason', requiresExplanation: true},
    ],
    TRFEXP: [
        {text: 'Pivot away from TransAmerica FE: Client requested: Wanted more coverage', requiresExplanation: false},
        {text: 'Pivot away from TransAmerica FE: Other: Other reason', requiresExplanation: true},
    ],
    // Generic default for any product code not in the list above
    default: [
        {text: 'Client requested a different product', requiresExplanation: false},
        {text: 'Client wants multiple policies with same carrier', requiresExplanation: false},
        {text: 'Eligibility concerns', requiresExplanation: false},
        {text: 'Other reason', requiresExplanation: true},
    ],
};
